import { render, staticRenderFns } from "./SimpleAlertDialog.vue?vue&type=template&id=22b94784&"
import script from "./SimpleAlertDialog.vue?vue&type=script&lang=ts&"
export * from "./SimpleAlertDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports